export enum FILE_TYPES {
  ALL_IMAGE = 'image/*',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  PDF = 'application/pdf',
  CSV = 'text/csv',
  TEXT = 'text/plain',
}
